const sign_up =
  'https://brrrrbot.outseta.com/auth?widgetMode=register#o-anonymous';
const sign_in =
  'https://brrrrbot.outseta.com/auth?widgetMode=login#o-anonymous';
const profile = 'https://brrrrbot.outseta.com/profile#o-authenticated';
const logout = '/#o-logout-link';
const support = 'https://brrrrbot.outseta.com/support/kb';
export { sign_up, sign_in, profile, logout, support };
